import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Atlante, AtlanteFormType } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import AtlanteForm from "./AtlanteForm"
import { useAtlanteCreate } from "../../hooks/atlanti"
import { initialValuesAtlante, validationSchemaAtlante } from "./AtlanteCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function AtlanteCreate() {
  const createAtlante = useAtlanteCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Atlanti", href: "/atlanti/atlanti" }, { label: "Creazione Atlante" }])

  const initialValues = useMemo(() => initialValuesAtlante(), [])
  const validationSchema = useMemo(() => validationSchemaAtlante(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo Atlante</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createAtlante.mutateAsync(values as AtlanteFormType).then((atlante) => {
                navigate(`/atlanti/atlanti/${atlante.id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <AtlanteForm />
                </Container>
                <BottomFormFixed url="/atlanti/atlanti" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
